import sukkotRelease from "./sukkot-release.json";
import flowingMatterRelease from "./flowing-matter-release.json";

const releases = {
    sukkot: sukkotRelease,
    "2026": flowingMatterRelease
};

export default releases;